@let ds = datasource();
@if (ds) {
  <DataTable
    [datasource]="ds"
    [columns]="columns"
    [height]="`calc(100vh - ${heightOffset()}px)`"
    (rowClick)="handleRowClick($event)"
  >
    <div ngProjectAs="data-table-header" row-layout paddingLeft="md">
      <div
        row-layout
        justifyContent="space-between"
        alignItems="center"
        [fullWidth]="true"
      >
        <Text
          role="headline-medium"
          display="block"
          color="on-background-variant"
          >{{ label() }}</Text
        >
        <button
          icon-button
          variant="ghost"
          symbolName="cached"
          size="md"
          (click)="reloadData()"
          [loading]="loading()"
        >
          reload
        </button>
      </div>
    </div>
  </DataTable>

  <Dialog [show]="showDialog()" (showing)="showDialog.set($event)">
    <DialogHeader>Log entry details</DialogHeader>
    <div stack-layout gap="sm" padding="md">
      @for (entry of details(); track entry) {
        <div>
          <div row-layout alignItems="center" gap="sm">
            @if (entry.message.includes('Error')) {
              <Symbol name="error" [opticalSize]="20" />
            }
            <Text display="block">{{ entry.message }}</Text>
            <ExpandToggle #toggle />
          </div>
          <Expand [collapsed]="toggle.collapsed()">
            <div stack-layout gap="sm">
              <Text role="body-2-short" display="block">
                ID: {{ entry.id }} <br />
                Application Name: {{ entry.applicationName }}<br />
                Event Type: {{ entry.eventType }} <br />
                User Id: {{ entry.userId }} <br />
                Log Level: {{ entry.logLevel }} <br />
                Log Level Description: {{ entry.logLevelDescription }} <br />
                Exception: {{ entry.exception }} <br />
                @if (Object.keys(entry.exceptionDetails).length > 0) {
                  Exception Details:<br />
                  <textarea style="width: 100%" rows="6">{{
                    JSON.stringify(entry.exceptionDetails, null, 2)
                  }}</textarea>
                  <br />
                }
                Timestamp: {{ entry.timestamp }} <br />
                @if (Object.keys(entry.additionalData).length > 0) {
                  Additional Data:<br />
                  <textarea style="width: 100%; font-size: small" rows="6">{{
                    JSON.stringify(entry.additionalData, null, 2)
                  }}</textarea>
                }
              </Text>
            </div>
          </Expand>
        </div>
      }
    </div>
  </Dialog>
}
<ng-template #statusCell let-status="jobStatus">
  @let normalizedStatus = status?.trim()?.toLowerCase();
  <div box-layout padding="sm">
    @if (
      normalizedStatus === 'completed' ||
      normalizedStatus === 'succeeded' ||
      normalizedStatus === 'sucess'
    ) {
      <Badge color="success">Success</Badge>
    } @else if (normalizedStatus === 'failure') {
      <Badge color="warn">Failed</Badge>
    } @else if (normalizedStatus === 'deleted') {
      <Badge color="warn">Deleted</Badge>
    } @else {
      <Badge>Processing</Badge>
    }
  </div>
</ng-template>
